<script> 
  import { fade } from "svelte/transition";
	import Load from "../components/Load.svelte" 
  import QrCode from "svelte-qrcode";
  import Alert from "../components/Alert.svelte"; 
  import Navigationbar from "../components/Navigationbar.svelte";

  //liblary
  import axios from "axios";
  import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });
  

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
   $: if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = []; 
  let itemsDisplay = false;
  setTimeout(() => {
    itemsDisplay = true; 
  }, 1000);
  let uid = Math.random().toString(36).substring(2);
  let data;
  if (settings.data.qr) {
    data = JSON.parse(settings.data.qr.data);
  } else {
    axios
      .post(settings.url + "/sipade/srt?authorization=" + settings.token, {
        surat: 0,
        jeniskpt: 1,
        nomor: "",
        ket: "",
        ttd: "-",
        type: 1,
      })
      .then(function (response) {
        
        location.reload(true);
      })
      .catch(function (error) {
        if (error.response.status == 401) {
          localStorage.removeItem("t"); 
          redirect("/login");
        } else {
          if (error.response.data.message) {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: error.response.data.message,
                color: "orange",
              },
            ];
          } else {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: "Anda belum terhubung dengan baik",
                color: "orange",
              },
            ];
          }
        }
      });
  }
  const capitalize = (s) => {
  if (typeof s !== 'string') return '' 
   s = s.toLowerCase().split(' ');
   for (var i = 0; i < s.length; i++) {
       // You do not need to check if i is larger than splitStr length, as your for does that for you
       // Assign it back to the array
       s[i] = s[i].charAt(0).toUpperCase() + s[i].substring(1);     
   }
   // Directly return the joined string
   return s.join(' ')

}
</script>
<svelte:head>
<title>Kartu Ke Dekatan</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
<Navigationbar
  backbtn="true"
  message={navigation['message']}
  title="Kartu Pelayanan" />
<main transition:fade class="container px-1 pt-24 mx-auto mb-32 lg:pt-24 md:pt-20 lg:px-0">
  <div class="pt-2 mx-auto my-5 lg:mt-10 lg:my-0">
     
    {#if itemsDisplay}
      <div
        id="kpt"
        class="absolute right-0 mx-auto my-5 mt-5 shadow-2xl kpt lg:mt-16 md:mt-5 lg:relative md:relative">
        <div class="cont">
          <div class="bio">
            <span class="text-sm font-bold uppercase">{data.pen.nm}</span>
            <br />
            <span class="text-xs">
              {data.pen.almt}
              RT.
              {data.pen.rt}/{data.pen.rw}
            </span>
            <br />
            <br />
            <p class="text-xs">{capitalize(data.rule.desa)}<br/>{capitalize(data.rule.kec)}<br/>{capitalize(data.rule.pem)}</p>
           
            <span class="text-xs font-semibold">
              {data.rule.kotakab},
              {data.rule.tglbuat}
            </span>
          </div>
          <div class="qr">
            <div class="logo">
              <img alt="Card Logo" src="./assets/logo/logo_icon.svg" class="mx-auto bg-white border rounded-lg">
            </div>
            <div style="padding: 2px 10px;" />
            <QrCode value="sipade:{data.pen.nik}" level="H" />
            <p class="font-mono bg-gray-100 qrfot"><b>{data.pen.nik}</b></p>
          </div>
        </div>
        <div class="text-xs font-bold fot">KARTU PELAYANAN TERPADU</div>
      </div>
      <div class="max-w-2xl mx-auto rounded-lg">
        <div class="w-full mx-auto my-5 mt-24 lg:my-0 lg:mt-0 md:mt-0">
          <div class="w-full mx-auto mb-2">
            <div
              class="flex flex-wrap justify-between p-5 pt-40 bg-white rounded-md shadow-md lg:pt-0 md:pt-0">
              <button
                on:click={() => window.print()}
                class="p-2 px-5 m-2 mx-auto text-center bg-orange-300 rounded cursor-pointer hover:shadow-lg">
                <svg
                  class="inline h-4 mr-2"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4 16H0V6h20v10h-4v4H4v-4zm2-4v6h8v-6H6zM4 0h12v5H4V0zM2
                    8v2h2V8H2zm4 0v2h2V8H6z" />
                </svg>
                Cetak Kartu
              </button>
              <p class="text-center">
                <b>KPT</b>
                atau
                <b>Kartu Pelayanan Terpadu</b>
                ini adalah tanda bahwa anda telah terdaftar dalam SIPADE (Sistem Informasi Pelayanan Desa) dan berguna
                untuk berbagai kebutuhan seperti, Pelayanan Administrasi dan layanan-layanan lain yang
                ada di *Desa.
                <br />
                <br />
                <span class="text-xs">
                  * Hanya Desa yang sudah bekerjasama<br/> 
                  Simpan kartu ini dengan sebaik-baiknya, kartu ini dapat anda
                  cetak atau gunakan secara digital
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    {:else}
    <Load/>
    {/if}
  </div>
</main>
